﻿export default class DataLayerNavigation {
    constructor(menu, breadcrumb, item, url) {
        this.menu = menu;
        this.breadcrumb = breadcrumb;
        this.item = item;
        this.url = url;
    }
}